import { Component } from 'vue'
import { RouteRecordRaw } from 'vue-router'

import { useCurUser } from '@/composables/useCurUser'

interface CatalogChildRoute {
  label: string
  component: () => Promise<Component>
}

export const catalogChildrenRoutes: Record<string, CatalogChildRoute> = {
  '3d': {
    label: '3D',
    component: () => import('@/apps/Catalog/views/map/3DMap.vue'),
  },
  '2d': {
    label: '2D',
    component: () => import('@/apps/Catalog/views/map/2DMap.vue'),
  },
  'street-view': {
    label: 'Street View',
    component: () => import('@/apps/Catalog/views/map/StreetView.vue'),
  },
}

export const catalogRoutes: RouteRecordRaw[] = [
  {
    name: 'cat',
    redirect: {
      name: 'catalog',
    },
    path: '/cat',
  },
  {
    path: '/catalog',
    name: 'catalog',
    beforeEnter: (_to, _from, next) => {
      const { is } = useCurUser()
      if (is.value.catExplorer || is.value.catSubmitter) {
        next()
      } else {
        next({ name: 'dashboard' })
      }
    },
    redirect: () => {
      return { name: 'catalog-start' }
    },
    component: () => import('@/apps/Catalog/CatalogPage.vue'),
    children: [
      {
        path: 'start',
        name: 'catalog-start',
        component: () => import('@/apps/Catalog/StartPage.vue'),
      },
      {
        path: 'view/:tab?',
        name: 'catalog-view',
        component: () => import('@/apps/Catalog/views/ViewSection.vue'),
        props: true,
      },
      {
        path: 'report',
        name: 'catalog-report',
        component: () => import('@/apps/Catalog/ReportPage.vue'),
      },
    ],
  },
]

export default catalogRoutes
